import React, { useEffect, useRef, useState } from "react";
import "./SurgeryCertificate.scss";
import { Button, Col, Row, Typography } from "antd";
import Sign from "components/common/PrintForm/Sign/Sign";
import ReactToPrint from "react-to-print";
import { useAppSelector } from "redux/hooks";
import { birthday2Age } from "helper/common";
import dayjs from "dayjs";
import { PPVoCam } from "../SurgeryDetail/config";
import { sharedDirectory } from "api";
import { Notification } from "components/common";
import { FORMAT_TIME } from "types/enums";
import moment from "moment";
import BoxBHYT from "pages/Pay/PayTab/ModalPrintPTT/BoxBHYT/BoxBHYT";

const { Text } = Typography;

const SurgeryCertificate = (props) => {
  const { detailInfo } = props;
  const printRef = useRef<any>();
  // const detailInfo = useAppSelector((e) => e.residentialNurse.detailInfo);
  const listDmPPPT = useAppSelector((e) => e.residentialNurse.listDmPPPT);

  const listDoctor = useAppSelector((e) => e.residentialNurse.listDoctor);
  const optionsIcd = useAppSelector((e) => e.residentialNurse.optionICD);

  const [danToc, setDanToc] = useState<any>(null);

  const [ppVoCam, setPPVoCam] = useState(null);
  const fetchDanToc = async () => {
    try {
      const response = await sharedDirectory.getListDanToc();
      setDanToc(response.data.data);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục dân tộc");
    }
  };
  useEffect(() => {
    fetchDanToc();
  }, []);
  useEffect(() => {
    if (detailInfo?.quaTrinhPhauThuat !== null) {
      const res = PPVoCam?.find((e) =>
        e.value === detailInfo?.quaTrinhPhauThuat.ppVoCam ? e : null
      );
      setPPVoCam(res);
    }
  }, [detailInfo]);

  const { closeModal } = props;
  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="phieu-cn">
      <div>
        <div ref={printRef} className="phieu-cn-print">
          <div>
            <Row justify={"space-between"}>
              <Col span={8}>
                <Row justify={"center"} style={{ fontWeight: "bold" }}>
                  BỘ Y TẾ
                </Row>
                <Row style={{ fontWeight: "bold", fontSize: "12px" }}>
                  BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                </Row>
                <Row></Row>
              </Col>
              <Col span={10}>
                <Row
                  style={{ fontWeight: "bold", fontSize: "12px" }}
                  justify={"center"}
                >
                  CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                </Row>
                <Row justify={"center"}>Độc lập – Tự do – Hạnh phúc</Row>
                <Row justify={"center"}>-----------</Row>
              </Col>
              <Col span={2}></Col>
              <Col span={4}>
                <Row>MS: 04/BV-01</Row>
                <Row>Sổ lưu trữ: </Row>
                <Row>Mã y tế: {detailInfo?.maBenhNhan}</Row>
              </Col>
            </Row>
            <Row
              justify={"center"}
              style={{
                fontWeight: "bold",
                padding: "5px 0 5px 0",
                fontSize: "24px",
              }}
            >
              GIẤY CHỨNG NHẬN PHẪU THUẬT
            </Row>
            <Row justify={"center"} style={{ paddingBottom: "10px" }}>
              Bệnh viện chuyên khoa Mắt Alina chứng nhận
            </Row>
            <div style={{ lineHeight: "1.5" }}>
              <Row>
                <Col span={16}>
                  Họ tên người bệnh: {detailInfo?.tenBenhNhan}
                </Col>
                <Col span={4}>Tuổi: {birthday2Age(detailInfo?.ngaySinh)}</Col>
                <Col span={4}>
                  Giới tính:{" "}
                  {detailInfo?.gioiTinh === 0
                    ? "Nam"
                    : detailInfo?.gioiTinh === 1
                    ? "Nữ"
                    : null}
                </Col>
              </Row>
              <Row>
                <Col span={16}>
                  Dân tộc:{" "}
                  {danToc &&
                    danToc?.find((e) => e.id === detailInfo?.danToc)?.name}
                </Col>
                <Col span={6}>Nghề nghiệp: {detailInfo?.ngheNghiep}</Col>
              </Row>
              <Row>
                <Col span={9}>
                  BHYT giá trị từ &emsp; {detailInfo?.bhytgiaTriTu}
                </Col>
                <Col span={7}>đến &emsp; {detailInfo?.bhytgiaTriDen}</Col>
                <Col span={8}>
                  <Typography.Text
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    Số thẻ: &nbsp;
                    <BoxBHYT code={detailInfo?.soTheBaoHiemYTe ?? ""} />
                    {/* <Typography.Text>
                      {thongTinIn?.soTheBaoHiemYTe}
                    </Typography.Text> */}
                  </Typography.Text>
                </Col>
              </Row>
              <Row>Địa chỉ: {detailInfo?.diaChi}</Row>
              <Row>Nơi làm việc: {detailInfo?.noiLamViec}</Row>
              {detailInfo?.ngayNhapVien ? (
                <Row>
                  <Col span={3}>Vào viện lúc:</Col>
                  {moment(detailInfo?.ngayKham).format(
                    "HH [giờ] mm [phút], [ngày] DD [tháng] MM [năm] YYYY"
                  )}
                </Row>
              ) : (
                <Row>
                  <Col span={3}>Vào viện lúc:</Col>
                  <Col span={2}>giờ</Col>
                  <Col span={3}>phút,ngày</Col>
                  <Col span={2}>tháng</Col>
                  <Col span={2}>năm</Col>
                </Row>
              )}
              {detailInfo?.ngayRaVien ? (
                <Row>
                  <Col span={3}>Ra viện lúc:</Col>
                  {moment
                    .utc(detailInfo?.ngayRaVien)
                    .format(
                      "HH [giờ] mm [phút], [ngày] DD [tháng] MM [năm] YYYY"
                    )}
                </Row>
              ) : (
                <Row>
                  <Col span={3}>Ra viện lúc:</Col>
                  <Col span={2}>giờ</Col>
                  <Col span={3}>phút,ngày</Col>
                  <Col span={2}>tháng</Col>
                  <Col span={2}>năm</Col>
                </Row>
              )}
              <Row>
                Chẩn đoán:{" "}
                {detailInfo?.quaTrinhPhauThuat?.chanDoanTruocPTList
                  ? optionsIcd?.find(
                      (e) =>
                        e.value ===
                          detailInfo?.quaTrinhPhauThuat?.chanDoanTruocPTList ||
                        e.label ===
                          detailInfo?.quaTrinhPhauThuat?.chanDoanTruocPTList ||
                        e.label ===
                          detailInfo?.quaTrinhPhauThuat?.chanDoanTruocPTList.trim()
                    )?.label +
                    " - " +
                    detailInfo?.quaTrinhPhauThuat?.chanDoanTruocPTValue
                  : detailInfo?.icdChanDoan
                  ? detailInfo?.icdChanDoan + " - "
                  : "" + detailInfo?.chanDoan
                  ? detailInfo?.chanDoan
                  : ""}
              </Row>
              <Row>
                Phương pháp phẫu thuật:{" "}
                {listDmPPPT?.find(
                  (e) =>
                    e.value === detailInfo?.quaTrinhPhauThuat?.ppPhauThuat ||
                    e.value === detailInfo?.dichVu
                )?.label || ""}
              </Row>
              <Row>
                Phẫu thuật viên:{" "}
                {detailInfo?.nhanSuPhauThuat?.bacSiPhauThuat?.list?.map(
                  (e, index) => (
                    <React.Fragment key={index}>
                      {e}
                      {index <
                        detailInfo.nhanSuPhauThuat.bacSiPhauThuat.list.length -
                          1 && " - "}
                    </React.Fragment>
                  )
                )}
              </Row>
              <Row>Phương pháp vô cảm: {ppVoCam && ppVoCam?.label}</Row>
            </div>
          </div>
          <Row className="sign" justify={"space-between"}>
            <Col span={7}>
              <Sign
                label="Phẫu thuật viên"
                span={18}
                showTime={true}
                chanKy={false}
                subLabel={false}
                isRow={false}
                justify={"center"}
                textAlign={"center"}
                style={{ marginTop: "0px" }}
              />
            </Col>
            <Col span={8}>
              <Sign
                label="Trưởng khoa"
                span={18}
                showTime={true}
                chanKy={false}
                subLabel={false}
                textAlign={"center"}
                justify={"center"}
                style={{ marginTop: "0px" }}
                isRow={false}
              />
            </Col>

            <Col span={8}>
              <Sign
                chanKy={false}
                label="Giám đốc"
                span={18}
                textAlign={"center"}
                justify={"center"}
                style={{ marginTop: "0px" }}
                time={detailInfo?.ngayChiDinh}
              />
            </Col>
          </Row>
        </div>
        <Row justify={"end"} gutter={[16, 16]} style={{ paddingTop: "30px" }}>
          <Col>
            <Button danger onClick={closeModal}>
              Hủy
            </Button>
          </Col>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="phieu-cn"
            onAfterPrint={closeModal}
          />
        </Row>
      </div>
    </div>
  );
};

export default SurgeryCertificate;
